import React, { Component, useState, useEffect, Fragment } from "react";
import axios from "axios";
import DealItems from "./DealItems";
import { VerifyHome } from "./VerifyComponents/VerifyHome";
import { Loading } from "./Loading";

export const Home = ({
  ap,
  deviceId,
  location,
  passPortal,
  postBalance,
  userReg,
  test
}) => {
  const [loading, setLoading] = useState(true);
  const [optionsVerify, setOptionsVerify] = useState([]);
  const [redirectDeal, setRedirectDeal] = useState(false);

  useEffect(() => {
    getInfoUsereg();
  }, []);

  const getInfoUsereg = async () => {
    try {
      let v = await getVerificationsByStore(Number(ap.ap_locationid));
      if (userReg) {
        if (v && v.length) {
          let opts = v.filter((opt) => {
            return !userReg[opt.key];
          });
          if (!userReg.userReg.email_date && userReg.email) {
            opts.push({
              key: "email_confirm",
              value: "email_confirm",
              label: "Confirmar correo",
            });
          }
          setOptionsVerify(opts);
        }
        //setUserReg(user);
      } else {
        setOptionsVerify(v);
      }
    } catch (error) {
      console.error("error: ", error);
    }
    setLoading(false);
  };


  const getVerificationsByStore = (storeID) => {
    return new Promise((resolve, reject) => {
      axios
        .get("/verifications", {
          params: {
            storeID,
          },
        })
        .then((v) => resolve(v.data.validations))
        .catch((e) => reject(e));
    });
  };

  const redirectUser = () => {
    // hacer peticion por tienda para la secuncua a verificar
    if (optionsVerify && optionsVerify.length) {
      if (!userReg) {
        return (
          <VerifyHome
            ap={ap}
            passPortal={passPortal}
            redirect={redirectDealItems}
            user={userReg}
            deviceId={deviceId}
            test={test}
            optionsVerify={optionsVerify}
          />
        );
      }
      if (
        optionsVerify.length === 1 &&
        optionsVerify.find((v) => v.key === "lealtad_num")
      ) {
        return (
          <DealItems
            ap={ap}
            deviceId={deviceId}
            location={location}
            test={test}
            passPortal={passPortal}
            postBalance={(c, it, ids) => postBalance(c, it, ids)}
            userReg={userReg}
          />
        );
      }
      return (
        <VerifyHome
          ap={ap}
          passPortal={passPortal}
          redirect={redirectDealItems}
          user={userReg}
          deviceId={deviceId}
          test={test}
          optionsVerify={optionsVerify}
        />
      );
    }

    return (
      <DealItems
        ap={ap}
        deviceId={deviceId}
        location={location}
        passPortal={passPortal}
        test={test}
        postBalance={(c, it, ids) => postBalance(c, it, ids)}
        userReg={userReg}
        />
    );
  };

  const redirectDealItems = async () => {
    setRedirectDeal(true);
    // post access
    try {
    } catch (error) {}
  };


  return (
    <Fragment >     
      {
        loading  ? (
          <Loading />
        ) : redirectDeal ? (
          <DealItems
            ap={ap}
            deviceId={deviceId}
            location={location}
            passPortal={passPortal}
            userReg={userReg}
            test={test}
            postBalance={(c, it, ids) => postBalance(c, it, ids)}
          />
        ) : (
          redirectUser()
        )
      }
    </Fragment>
  );
};
